import cn from 'classnames';
import { useMemo } from 'react';
import { Stack } from '@mui/material';
import { useProgramPageRedirect } from '@pages/programs/program-page/helpres.ts';
import { Menu } from '@widgets/programs/index.ts';
import {
  getProgramAuthorName,
  onProgramCardClick,
} from '@widgets/programs/program-card/helprers.ts';
import { ProgramCardProps } from '@widgets/programs/program-card/type.ts';
import { OpenIndicatorWithImage } from '@features/common/open-indicator/index.ts';
import { SmallCardCost } from '@features/common/SmallCardCost/index.tsx';
import { SmallCardStatus } from '@features/common/SmallCardStatus/index.tsx';
import { useProgramAuthor } from '@features/programs/index.ts';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import { Card } from '@shared/ui/index.ts';
import { TextOverflow } from '@shared/ui/TextOverflow/index.tsx';
import st from './styles.module.scss';

export const GridProgramCard = (props: ProgramCardProps) => {
  const { program, onClick, needDropDawnShowUp, activeTab } = props;
  const { code } = useModuleByCodeParam();
  const { doRedirectWithSavePageUrl } = useProgramPageRedirect();

  const { opened, publication, moderation_status, cost, pk, favorite, is_paid, title, author } =
    program;

  const { isAuthor } = useProgramAuthor(program.author.id);

  const isHasToShowTitleInTwoStrings = useMemo(() => {
    let output = false;
    if (
      !(
        !is_paid ||
        (isAuthor && cost !== '0') ||
        (isAuthor && activeTab !== 'all') ||
        favorite ||
        (publication?.is_published && isAuthor)
      )
    ) {
      output = true;
    }
    return output;
  }, [isAuthor, cost, activeTab, favorite, publication, is_paid]);

  return (
    <Card
      className={st.card}
      onClick={(event) =>
        onProgramCardClick({
          event,
          onClick,
          doRedirectWithSavePageUrl,
          url: `/programs/${code}/program/${program.pk}`,
        })
      }
    >
      <OpenIndicatorWithImage
        // wrapperWithStatusClassName={st.wrapperWithStatusClassName}
        wrapperClassName={st.imageWrapper}
        imageClassName={st.image}
        imageWithStatusClassName={st.imageWithStatus}
        activeTab={activeTab}
        isAuthor={isAuthor}
        isOpened={opened}
        isPublished={publication?.is_published || false}
        modStatus={moderation_status}
        imgSrc={program?.promo_image}
      />
      <Stack direction={'column'} pl={'4px'}>
        <Stack direction={'row'} className={st.title_and_author_name_wrapper}>
          <div className={st.title_and_author}>
            <TextOverflow
              className={cn(st.title, isHasToShowTitleInTwoStrings && st.in_two_strings)}
            >
              {title}
            </TextOverflow>
            <TextOverflow className={st.author_name}>{getProgramAuthorName(program)}</TextOverflow>
          </div>
          <Menu
            id={pk}
            needDropDawnShowUp={needDropDawnShowUp}
            authorId={author.id}
            coachId={author?.coach?.id}
            isFavorite={favorite}
            isPaid={is_paid}
            onMenuItemClick={onClick}
          />
        </Stack>

        <Stack direction={'row'}>
          <SmallCardCost isAuthor={isAuthor} cost={cost} is_paid={program?.is_paid} />
          <SmallCardStatus
            isNeedToShowOnlyIcon={true}
            className={st.status}
            moderationStatus={moderation_status}
            isAuthor={isAuthor}
            isPublished={publication?.is_published}
            isPaid={is_paid}
            // cost={cost}
            isFavorite={favorite}
          />
        </Stack>
      </Stack>
    </Card>
  );
};
